import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {ProtectedRoute} from '../auth/require-authorization';
import {ActionClassListing} from './action-class-listing';
import {
  ActionClassCreate,
  ActionClassUpdate,
} from './action-class-create-update';

export const ActionClassRoutes: RouteObject = {
  path: ROUTES.ADMIN.ACTION_CLASSES.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.ACTION_CLASSES.INDEX.path,
      element: <ActionClassListing />,
    },
    {
      path: ROUTES.ADMIN.ACTION_CLASSES.CREATE.path,
      element: <ActionClassCreate />,
    },
    {
      path: ROUTES.ADMIN.ACTION_CLASSES.DETAIL.path,
      element: <ActionClassUpdate />,
    },
  ],
};
